export default __webpack_public_path__ + "static/media/icn-shopping-cart.b22e3994.svg";